export default __webpack_public_path__ + "static/media/sponsor-8.e29480ee.svg";